import React, { useState } from "react";
import styles from "./RsvpGuestMeal.module.css";
import { Col, Layout } from "antd";
import Header from "../../../../components/header/Header";
import bgcImage from "../../../../assets/bgcimage.png";
import Rsvp from "../../../../assets/rsvp10.png";
import ModelImage from "../../../../assets/modelscreen.png";
import TextComponent from "../../../../components/textComponent/TextComponent";
import SubmitBotton from "../../../../components/submitButton/SubmitButton";
import { BiSolidChevronRightCircle } from "react-icons/bi";

import Modal from "../../../../components/modal/Modal";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { InputField } from "../../../../components";
import { showAlert } from "../../../../Store/Actions/GeneralActions";

const Rsvp10 = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const navigate = useNavigate();
  const { state } = useLocation();
  const rsvpData = useSelector(
    (state) => state?.GuestReducer?.guestRsvpDetails
  );
  const dispatch = useDispatch();
  const [selectedMeal, setselectedMeal] = useState([]);
  // const myStyle = {
  //   backgroundImage: `url(${bgcImage})`,
  //   backgroundRepeat: "no-repeat",
  // };
  return (
    <div className={styles.mainContainer}>
      <Layout className="site-layout">
        <Header
          mainHeader={styles.headerColor}
          isProfile={true}
          title={"RSVP"}
          style={{ padding: 0, background: "var(--white-color)", height: 85 }}
          onBackClick={() => navigate(-1)}
        />
      </Layout>
      <div className={styles.mainDiv}>
        <div className={styles.innerDiv}>
          <div className={styles.innerDiv2}>
            <TextComponent textClass={styles.title} text="Meal" />
            <TextComponent
              textClass={styles.text3}
              text="What would you like to be served? Don't forget to select your meal choice below!"
            />
            <div className={styles.col}>
              {rsvpData?.meals?.map((item) => {
                return (
                  <div
                    className={`${styles.col2} ${
                      selectedMeal.find((data) => data.id == item.id)
                        ? styles.col2Selected
                        : ""
                    } `}
                    key={item?.id}
                    onClick={() => {
                      if (selectedMeal.find((data) => data.id == item.id)) {
                        let arr = selectedMeal.filter(
                          (data) => data.id != item.id
                        );
                        setselectedMeal(arr);
                      } else {
                        let arr = [...selectedMeal, { ...item, quantity: 1 }];
                        setselectedMeal(arr);
                      }
                    }}
                  >
                    <TextComponent textClass={styles.text2} text={item?.name} />
                    <TextComponent
                      textClass={styles.text4}
                      text={item.description}
                    />
                    {selectedMeal.find((data) => data.id == item.id) && (
                      <InputField
                        // label="Quantity"
                        styles={styles.inputClass}
                        placeholder={"Enter Quantity"}
                        type="number"
                        onClick={(e) => {
                          e.stopPropagation();
                        }}
                        value={
                          selectedMeal.find((data) => data.id == item.id)
                            .quantity
                        }
                        onChange={(e) => {
                          let index = selectedMeal.findIndex(
                            (data) => data.id == item.id
                          );
                          setselectedMeal((prev) => {
                            let arr = [...prev];
                            prev[index].quantity = e.target.value;
                            return arr;
                          });
                        }}
                      />
                    )}
                  </div>
                );
              })}
            </div>
            <div className={styles.footer}>
              <BiSolidChevronRightCircle
                className={styles.con1}
                size={30}
                onClick={() => {
                  if (selectedMeal.length <= 0) {
                    dispatch(
                      showAlert({
                        type: "error",
                        message: "Please select meal",
                      })
                    );
                    return;
                  }
                  if (selectedMeal.find((data) => data.quantity <= 0)) {
                    dispatch(
                      showAlert({
                        type: "error",
                        message: "Please enter meal quantity 1 or greater",
                      })
                    );
                    return;
                  }
                  navigate("/rsvp/rsvpGuestInvitation", {
                    state: { ...state, selectedMeal },
                  });
                }}
              />
            </div>
          </div>
        </div>
        <div className={styles.imgContainer}>
          <img className={styles.innerImg} src={Rsvp} />
        </div>
      </div>
      <Modal
        setIsModalOpen={setIsModalVisible}
        closable={true}
        className={styles.model}
        isModalOpen={isModalVisible}
      >
        <TextComponent textClass={styles.text} text="Event Room" />
        <img className={styles.modelImage} src={ModelImage} />
      </Modal>
    </div>
  );
};

export default Rsvp10;
